export default __webpack_public_path__ + "static/media/inviteBlockDogs@2x.9cfa5043.png";